import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/inquiry_img_01.svg")